import React from "react";
import { ClipLoader } from 'react-spinners';

const AddressForm = (props) => {
    const { userAddress, onUserDetailSave, handleChange, formData, stateData, loading, showForm, handleBackToAddresses } = props;
    return (
        <>
            <div className="box-border">
                <span className="address_description">Select a delivery address from your address book or enter a new one for delivery.</span>
                <form onSubmit={onUserDetailSave} className="mt-4">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <input type="text" name="name" id="fullname" className="form-control" placeholder="Full Name" required value={formData.name} onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                            <div className="form-group">
                                <input type="email" name="emailId" id="email" className="form-control" placeholder="Email" required value={formData.emailId} onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                            <div className="form-group">
                                <input type="text" name="contatctNo" id="mobilenumber" className="form-control" placeholder="Mobile Number" required value={formData.contatctNo} onChange={handleChange} maxLength={10}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                            <div className="form-group">
                                <input type="text" name="addressLine1" id="addressline1" className="form-control" placeholder="Address Line1" required value={formData.addressLine1} onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                            <div className="form-group">
                                <input type="text" name="addressLine2" id="addressline2" className="form-control" placeholder="Address Line2" value={formData.addressLine2} onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                            <div className="form-group">
                                <select name="countryId" id="country" className="form-control" value={formData.countryId} onChange={handleChange} required >
                                    <option key={formData.countryId} value={formData.countryId}>India</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                            <div className="form-group">
                                <select name="stateId" id="state" className="form-control state_input" value={formData.stateId} onChange={handleChange} required >
                                    <option value="0" className="option">Select state</option>
                                    {stateData?.map((state, i) => (
                                        <option key={state.stateId} value={state.stateId} className="option">{state?.stateName}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                            <div className="form-group">
                                <input type="text" name="city" id="city" className="form-control" placeholder="City" required value={formData.city} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-12">
                            <div className="form-group">
                                <input type="text" name="pincode" id="zip" className="form-control" placeholder="Zip / postal code" required value={formData.pincode} onChange={handleChange} maxLength={6} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-center col-12">
                            <button type="submit" id="" className="web_button py-2 col-lg-4 fontsize-18 w-100" disabled={loading} >
                                {loading ? (
                                    <ClipLoader color="#fff" size={20} />
                                ) : (
                                    'Submit'
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            {userAddress != null && showForm ?
                <div className="add_more_address_btn mt-2">
                    <button className="web_buttons px-2" onClick={handleBackToAddresses}>Back</button>
                </div> : null
            }
        </>
    )
}

export default AddressForm;